<template>
  <div>
    <carousel
      :autoplay="true"
      :autoplayTimeout="2000"
      :loop="true"
      :navigationEnabled="false"
      :pagination-enabled="false"
      :pauseOnOver="false"
      :perPageCustom="[
        [768, 3],
        [1024, 4],
      ]"
      ref="carouselSelector"
    >
      <slide
        :class="
          Object.keys(items)[0] == index
            ? 'passport_tabs'
            : 'passport_tabs_inactive'
        "
        :id="`tab-passports-${item}`"
        v-for="(item, index) in items"
        :key="index"
      >
        <div>
          <button @click="changePassportsShownByYear(item, index)">
            {{ item }}
          </button>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
    changePassportsShownByYear(year) {
      const current_open_tab =
        document.getElementsByClassName("event_year_active")[0];
      if (current_open_tab) {
        current_open_tab.classList.remove("event_year_active");
        current_open_tab.classList.add("event_year_inactive");
      }
      const tab_to_open = document.getElementById(`${year}`);
      if (tab_to_open) {
        tab_to_open.classList.remove("event_year_inactive");
        tab_to_open.classList.add("event_year_active");
      }

      const current_clicked_tab =
        document.getElementsByClassName("passport_tabs")[0];
      if (current_clicked_tab) {
        current_clicked_tab.classList.remove("passport_tabs");
        current_clicked_tab.classList.add("passport_tabs_inactive");
      }
      const tab_just_clicked = document.getElementById(`tab-passports-${year}`);
      if (tab_just_clicked) {
        tab_just_clicked.classList.remove("passport_tabs_inactive");
        tab_just_clicked.classList.add("passport_tabs");
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>